export const MOCKS_LAST_NAMES = [
  'Blick',
  'Rippin',
  'Okuneva',
  'Ziemann',
  'Lockman',
  'Torphy',
  'Moore',
  'Toy',
  'Rempel',
  'Abernathy',
  'Jast',
  'Volkman',
  'Spinka',
  'Feest',
  'Spinka',
  'Treutel',
  'Emmerich',
  'Metz',
  'Wolff',
  'Swift',
  'Blick',
  'Stokes',
  'Schmitt',
  'Hansen',
  'Beier',
  'Powlowski',
  'Denesik',
  'Kohler',
  'Carter',
  'Nader',
  'Gerlach',
  'Casper',
  'Ward',
  'Hermiston',
  'Rutherford',
  'Boehm',
  'Jast',
  'Jerde',
  'Volkman',
  'Rowe',
  'Kutch',
  'Greenholt',
  'Wilderman',
  'Johnston',
  'Rolfson',
  'Schultz',
  'Hirthe',
  'Pouros',
  'Schulist',
  'Pouros',
  'Gutmann',
  'Bashirian',
  'Grimes',
  'Funk',
  'Hudson',
  'Hane',
  'Rogahn',
  'Wisoky',
  'Walsh',
  'Russel',
  'Cassin',
  'Beier',
  'Skiles',
  'Donnelly',
  'Stoltenberg',
  'Pollich',
  'Armstrong',
  'Dickens',
  'Mayer',
  'Jerde',
  'Bernier',
  'Kuhn',
  'Dickinson',
  'Runolfsson',
  'Lebsack',
  'Rolfson',
  'Hane',
  'Klein',
  'Reinger',
  'Reynolds',
  'Strosin',
  'Wehner',
  'Denesik',
  'Altenwerth',
  'Rosenbaum',
  'Gorczany',
  'Kutch',
  'Heaney',
  'Smith',
  'Daniel',
  'Mante',
  'Dietrich',
  'Armstrong',
  'Towne',
  'Hammes',
  'Kessler',
  'Parisian',
  'Haag',
  'Shanahan',
  'Fritsch',
];

export const MOCKS_FIRST_NAMES = [
  'Melvina',
  'Hilario',
  'Alexandra',
  'Kendrick',
  'Dee',
  'Helene',
  'Nikita',
  'Demetrius',
  'Harvey',
  'Magdalen',
  'Alexandra',
  'Davin',
  'Estefania',
  'Tiffany',
  'Santino',
  'Lillian',
  'Lorenzo',
  'Allene',
  'Verner',
  'Paige',
  'Priscilla',
  'Norval',
  'Shany',
  'Toby',
  'Karson',
  'Reese',
  'Ena',
  'Grayson',
  'Gretchen',
  'Benton',
  'Daren',
  'Beulah',
  'Aliya',
  'Olin',
  'Stevie',
  'Lempi',
  'Anthony',
  'Brennan',
  'Dannie',
  'Chaim',
  'Noemi',
  'Kristoffer',
  'Lonzo',
  'Miguel',
  'Ethel',
  'Erica',
  'Elsie',
  'Roxane',
  'Shana',
  'Jerry',
  'Juana',
  'Murl',
  'Amani',
  'Cordia',
  'Kiera',
  'Jasper',
  'Maximilian',
  'Liza',
  'Rae',
  'Claud',
  'Hailee',
  'Isac',
  'Darrel',
  'Jammie',
  'Scottie',
  'Odie',
  'Orval',
  'Alvis',
  'Kirstin',
  'Joshua',
  'Gideon',
  'Addie',
  'Crawford',
  'Mariah',
  'Misty',
  'Lyric',
  'Dallin',
  'Dimitri',
  'Marquis',
  'Newell',
  'Gunner',
  'Lilly',
  'Roma',
  'Jada',
  'Brando',
  'Dawn',
  'Bethel',
  'Abner',
  'Claudia',
  'Novella',
  'Grayson',
  'Ezequiel',
  'Hillary',
  'John',
  'Eliezer',
  'Mark',
  'Marquis',
  'June',
  'Clotilde',
  'Alaina',
];

export const MOCKS_PHONES = [
  '5556857786',
  '5552124756',
  '5559349460',
  '5558820545',
  '5558584215',
  '5551720862',
  '5554916435',
  '5551371342',
  '5553253026',
  '5550194327',
  '5551237123',
  '5550373505',
  '5559143774',
  '5555471935',
  '5551717307',
  '5551840719',
  '5554683418',
  '5553852850',
  '5557974784',
  '5552630371',
  '5558755431',
  '5559414938',
  '5550687985',
  '5558282537',
  '5557734628',
  '5550913549',
  '5553894651',
  '5554062589',
  '5559208288',
  '5559982087',
  '5554451549',
  '5553392874',
  '5558150024',
  '5554621833',
  '5553165443',
  '5557736798',
  '5552676206',
  '5559760632',
  '5552981132',
  '5550185343',
  '5555263398',
  '5555437061',
  '5550359523',
  '5551637830',
  '5555245065',
  '5558043642',
  '5556930692',
  '5559362577',
  '5559917531',
  '5554565651',
  '5557283014',
  '5558178693',
  '5558290108',
  '5553568320',
  '5555754732',
  '5551551745',
  '5553462750',
  '5550005514',
  '5551688087',
  '5550785058',
  '5551637658',
  '5550682022',
  '5556319611',
  '5550504466',
  '5552446172',
  '5556418075',
  '5558780329',
  '5552092337',
  '5553061256',
  '5554733531',
  '5551244314',
  '5556846942',
  '5552171500',
  '5553207646',
  '5550817269',
  '5553002815',
  '5551288139',
  '5550377738',
  '5552869261',
  '5550366150',
  '5557345370',
  '5555094375',
  '5558261150',
  '5559313295',
  '5556255107',
  '5558091013',
  '5558575780',
  '5550679845',
  '5552795650',
  '5551847393',
  '5554360323',
  '5557842613',
  '5550753395',
  '5552319567',
  '5554910374',
  '5554462335',
  '5554510823',
  '5555949289',
  '5557148557',
  '5558146378',
];

const MOCKS_EMAILS = [
  'Leatha.Shields31@gmail.com',
  'Maximillian_Pouros@gmail.com',
  'Chadd2@hotmail.com',
  'Major_Kassulke@hotmail.com',
  'Willis.Lesch@gmail.com',
  'Electa51@gmail.com',
  'Deborah.Lueilwitz@hotmail.com',
  'Efrain40@hotmail.com',
  'Flossie.Breitenberg60@gmail.com',
  'Daryl_Bruen@hotmail.com',
  'Timothy14@yahoo.com',
  'Frederik3@gmail.com',
  'Lamont.Langworth23@yahoo.com',
  'Mandy_Abshire0@hotmail.com',
  'Tracy_Treutel@hotmail.com',
  'Lora67@yahoo.com',
  'Cristian_Schiller@yahoo.com',
  'Taryn59@yahoo.com',
  'Fritz_Corwin@gmail.com',
  'Kaylie_Marks@yahoo.com',
  'Antonietta_Halvorson@hotmail.com',
  'Stacy.Hamill@gmail.com',
  'Favian_Brakus64@gmail.com',
  'Ned_Bashirian44@hotmail.com',
  'Dakota56@gmail.com',
  'Florian.Huel80@gmail.com',
  'Anastasia60@yahoo.com',
  'Lorena_Kulas86@yahoo.com',
  'Emmalee_Halvorson@hotmail.com',
  'Jovan11@gmail.com',
  'Karina84@hotmail.com',
  'Elinore.Zboncak47@yahoo.com',
  'Ed.Robel@gmail.com',
  'Kennedy.Waters76@gmail.com',
  'Jamie68@gmail.com',
  'Helena_Grady44@yahoo.com',
  'Aaron.Pacocha@hotmail.com',
  'Darryl52@hotmail.com',
  'Dusty_Balistreri@gmail.com',
  'Rodger40@yahoo.com',
  'Mac.Ortiz@hotmail.com',
  'Emmalee.Schamberger73@yahoo.com',
  'Zachariah.Dooley@yahoo.com',
  'Josefa.Harvey8@gmail.com',
  'Brock22@yahoo.com',
  'Liam_Langosh58@yahoo.com',
  'Elmore.Morar@hotmail.com',
  'Dane_Quigley@gmail.com',
  'Mathias54@hotmail.com',
  'Johnnie_Torp@yahoo.com',
  'Georgianna.Green42@yahoo.com',
  'Sterling_Rice4@hotmail.com',
  'Dale_Torphy@yahoo.com',
  'Elva.Schmeler@hotmail.com',
  'Selina.MacGyver@yahoo.com',
  'Janae_Hilpert@gmail.com',
  'Vida.Hintz13@hotmail.com',
  'Shanelle.Gislason@gmail.com',
  'Jaren.Prosacco52@yahoo.com',
  'Napoleon.Walsh24@hotmail.com',
  'Harvey.Moore46@yahoo.com',
  'Verna_Schimmel@yahoo.com',
  'Eden96@hotmail.com',
  'Elva.Rath20@gmail.com',
  'Sean.Wolff@hotmail.com',
  'Billy65@yahoo.com',
  'Adolph_Muller8@yahoo.com',
  'Keaton_Collins16@yahoo.com',
  'Avery_Mayer72@hotmail.com',
  'Kamille_Mueller91@yahoo.com',
  'Andreanne.Ziemann@yahoo.com',
  'Theron99@hotmail.com',
  'Noble54@hotmail.com',
  'Lavern96@yahoo.com',
  'Kristy_Harvey23@yahoo.com',
  'Ena.Cruickshank@gmail.com',
  'Randal96@hotmail.com',
  'Joey_Volkman34@yahoo.com',
  'Kieran_Hammes34@hotmail.com',
  'Oleta_Batz58@yahoo.com',
  'Lois66@gmail.com',
  'Kristian_Romaguera60@gmail.com',
  'Lucius.Gleichner@hotmail.com',
  'Delphine.Koch88@hotmail.com',
  'Christop.Gusikowski@gmail.com',
  'Adalberto.Fadel@gmail.com',
  'Amya.Schuster@hotmail.com',
  'Dianna.Green39@gmail.com',
  'Valentine45@hotmail.com',
  'Edgardo.Moen10@hotmail.com',
  'Anastasia6@yahoo.com',
  'Jonathon27@yahoo.com',
  'Gilda.Senger58@gmail.com',
  'Evangeline_Schuppe50@yahoo.com',
  'Kaylin90@yahoo.com',
  'Viviane10@hotmail.com',
  'Antonia_Stoltenberg@yahoo.com',
  'Kristina.Hermann@hotmail.com',
  'Eli.Cormier14@gmail.com',
  'Bulah.Lockman82@hotmail.com',
];

const MOCKS_STREET_ADDRESS = [
  '4198 Deshaun Keys',
  '69362 West Prairie',
  '75085 Pacocha Lakes',
  '9935 Colten Coves',
  '09267 Octavia Spur',
  '117 Lynch Heights',
  '500 Willms Wells',
  '84297 Rigoberto Canyon',
  '571 Cummings Bypass',
  '575 Lynch Coves',
  '557 Dannie Drives',
  '3704 Lynch Haven',
  '33179 Dustin Port',
  '4805 Hoppe Mountains',
  '715 Gislason Islands',
  '647 Blanda Hills',
  '265 Boris Square',
  '228 Grayce Street',
  '33914 Albina Fork',
  '38069 Huels Track',
  '90677 Peter Turnpike',
  '965 Janice River',
  '2596 Earnestine Flat',
  '36599 Monahan Gardens',
  '73919 Lockman Parks',
  '655 Greenfelder Viaduct',
  '696 Estell Neck',
  '71382 Delilah Causeway',
  '0793 Doyle Knolls',
  '58040 Hammes Ways',
  '15679 Delia Well',
  '3818 Tromp Brooks',
  '61241 Efren Trail',
  '915 Malika Springs',
  '090 Harber Locks',
  '626 Marcia Drive',
  '41648 Verla Ramp',
  '576 Norbert Street',
  '3163 Keeling Key',
  '435 Runolfsdottir Walk',
  '681 Green Junctions',
  '656 Maurine Views',
  '98755 Dave Harbors',
  '04956 MacGyver Pike',
  '5295 Elmore Keys',
  '95016 Giuseppe Streets',
  '382 Marcelino Knoll',
  '3815 Rosina Route',
  '927 Beier Common',
  '7584 Franco Dale',
  '2477 Nitzsche Meadows',
  '949 Roger Way',
  '03913 Joanie Spring',
  '71391 Viviane Course',
  '74460 Carter Roads',
  '4277 Ullrich Mill',
  '74439 Koby Meadow',
  '47852 Albin Circles',
  '290 Rolfson Square',
  '4091 Thompson Road',
  '5395 Trey Harbors',
  '020 Calista Dam',
  '299 Leuschke Cove',
  '3968 Seth Square',
  '596 Retta Locks',
  '603 Gleichner Fields',
  '08440 Beier Creek',
  '103 Willard Run',
  '51849 Corkery Summit',
  '511 Keeley Center',
  '98432 Mike Glen',
  '734 Howe Mill',
  '65903 Reinger Cliffs',
  '95324 Wilderman Mission',
  '4420 Kessler Heights',
  '86583 Justine Turnpike',
  '8660 Prosacco Springs',
  '65545 Fermin Village',
  '39195 Garret Glens',
  '2001 Alycia Center',
  '387 Carter Rest',
  '6651 Kohler Circle',
  '51837 Gorczany Harbors',
  '08794 Stuart Fall',
  '1668 Jace Manor',
  '165 Kris Underpass',
  '23232 Wehner Oval',
  '195 Rico Divide',
  '88004 White Lights',
  '63989 Hoppe Manors',
  '3569 Sonia Wall',
  '080 Isai Heights',
  '412 Mathias Square',
  '51090 Fermin Views',
  '7572 Natasha Mall',
  '1991 Kerluke Shore',
  '8218 Elenor Field',
  '438 Makayla Turnpike',
  '80691 Caden Prairie',
  '361 Dave Falls',
];

export const getMockedLastName = () => {
  return MOCKS_LAST_NAMES[Math.floor(Math.random() * MOCKS_LAST_NAMES.length)];
};

export const getMockedFirstName = () => {
  return MOCKS_FIRST_NAMES[Math.floor(Math.random() * MOCKS_FIRST_NAMES.length)];
};

export const getMockedPhone = () => {
  return MOCKS_PHONES[Math.floor(Math.random() * MOCKS_PHONES.length)];
};

export const getMockedEmail = () => {
  return MOCKS_EMAILS[Math.floor(Math.random() * MOCKS_EMAILS.length)];
};

export const getMockedStreetAddress = () => {
  return MOCKS_STREET_ADDRESS[Math.floor(Math.random() * MOCKS_STREET_ADDRESS.length)];
};
